import React, { Component } from "react";
import ModalItem from "../../../../Components/ModalItem";
import {
  Row,
  Col,
  Collapse,
  Typography,
  Tag,
  List,
  Divider,
  Spin,
  message,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import dayjs from "dayjs";

const { Panel } = Collapse;
const { Text, Title } = Typography;

class ModalDetalleEnvio extends Component {
  state = {
    detalleCompleto: null,
    loadingDetalle: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.data?._id) {
      this.consultarDetalles(this.props.data._id);
    }

    if (!this.props.visible && prevProps.visible) {
      this.setState({ detalleCompleto: null });
    }
  }

  consultarDetalles = async (envioGeneralId) => {
    this.setState({ loadingDetalle: true });

    await axios
      .post(
        "correosEnviadosGeneral/selectCorreosGeneralPorId",
        { envioGeneralId: envioGeneralId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data?.success === 2 && res.data.envioGeneral) {
          this.setState({ detalleCompleto: res.data.envioGeneral[0] });
        } else {
          console.error(
            "No se pudo cargar el detalle completo:",
            res.data?.message
          );
          message.error(
            res.data?.message || "Error al cargar los detalles del envío."
          );
          this.props.onCancel();
        }
      })
      .catch((error) => {
        console.error("Error al obtener el detalle del envío:", error);
        message.error("Error de red al obtener los detalles.");
        this.props.onCancel();
      })
      .finally(() => {
        this.setState({ loadingDetalle: false });
      });
  };

  renderDetalleItem = (item, isSuccess) => {
    const icon = isSuccess ? (
      <CheckCircleOutlined style={{ color: "#52c41a" }} />
    ) : (
      <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
    );

    return (
      <List.Item
        key={item.clienteId}
        style={{ padding: "8px 0", borderBottom: "1px dashed #f0f0f0" }}
      >
        <List.Item.Meta
          avatar={icon}
          title={<Text strong>{item.nombreCliente}</Text>}
          description={
            <>
              {item.motivoNoEnvio ? (
                <Text type="secondary">Fallo: {item.motivoNoEnvio}</Text>
              ) : (
                <Text type="secondary">
                  Correo:{" "}
                  {item.correoDestinatario || "Correo no registrado/Inválido"}
                </Text>
              )}
              <br />
            </>
          }
        />
      </List.Item>
    );
  };

  render() {
    const { visible, onCancel, data } = this.props;
    const { loadingDetalle, detalleCompleto } = this.state;
    const currentData = detalleCompleto || data;

    const correosEnviados = currentData?.correosEnviados || [];
    const correosNoEnviados = currentData?.correosNoEnviados || [];
    const fechaEnvio = currentData?.createdAt
      ? dayjs(currentData.createdAt).format("DD/MM/YYYY HH:mm")
      : "Fecha no disponible";
    const totalEnviados = correosEnviados.length;
    const totalNoEnviados = correosNoEnviados.length; // Título del Modal

    const modalTitle = (
      <Title level={4} style={{ marginBottom: 0, color: "#333" }}>
        Detalles del Envío ID
      </Title>
    );

    return (
      <ModalItem
        visible={visible}
        onCancel={onCancel}
        title={modalTitle}
        footer={false}
        width={750}
        paddingTop={false}
        closable={!loadingDetalle}
        maskClosable={!loadingDetalle}
        spinning={loadingDetalle}
      >
        <Spin
          spinning={loadingDetalle}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        >
          {currentData && (
            <div style={{ marginBottom: 15, padding: "10px 0" }}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Text strong>Fecha y Hora del Envío: </Text>
                  <Text>{fechaEnvio}</Text>
                  <Divider style={{ margin: "10px 0" }} />
                </Col>
                <Col xs={24} sm={8}>
                  <Text strong>Tipo:</Text>
                  <Tag
                    color={
                      currentData?.tipoEnvio === "Automático"
                        ? "blue"
                        : "orange"
                    }
                    style={{ marginLeft: 8, fontWeight: "bold" }}
                  >
                    {currentData?.tipoEnvio}
                  </Tag>
                </Col>
                <Col xs={24} sm={16} style={{ textAlign: "right" }}>
                  <Text strong>Total Cobro Pendiente:</Text>
                  <Text style={{ fontSize: 16, marginLeft: 8 }}>
                    {currentData?.cobroTotal?.toLocaleString("es-MX", {
                      style: "currency",
                      currency: "MXN",
                    }) || "$0.00"}
                  </Text>
                </Col>
              </Row>

              <Collapse
                defaultActiveKey={["enviados"]}
                style={{ marginBottom: 15 }}
              >
                {/* Panel para Correos Enviados */}
                <Panel
                  header={
                    <span style={{ fontWeight: "bold" }}>
                      <CheckCircleOutlined style={{ color: "#52c41a" }} />{" "}
                      Correos Enviados Exitosamente ({totalEnviados})
                    </span>
                  }
                  key="enviados"
                  disabled={totalEnviados === 0}
                >
                  <List
                    dataSource={correosEnviados}
                    renderItem={(item) => this.renderDetalleItem(item, true)}
                    locale={{
                      emptyText: (
                        <Text type="secondary">
                          No se enviaron correos exitosamente en este lote.
                        </Text>
                      ),
                    }}
                  />
                </Panel>

                {/* Panel para Correos No Enviados */}
                <Panel
                  header={
                    <span style={{ fontWeight: "bold" }}>
                      <CloseCircleOutlined style={{ color: "#ff4d4f" }} />{" "}
                      Correos No Enviados ({totalNoEnviados})
                    </span>
                  }
                  key="noEnviados"
                  disabled={totalNoEnviados === 0}
                >
                  <List
                    dataSource={correosNoEnviados}
                    renderItem={(item) => this.renderDetalleItem(item, false)}
                    locale={{
                      emptyText: (
                        <Text type="secondary">
                          No hubo correos fallidos en este lote.
                        </Text>
                      ),
                    }}
                  />
                </Panel>
              </Collapse>
            </div>
          )}
        </Spin>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalDetalleEnvio);
